module.exports = __webpack_public_path__ + "static/BLOG-TITLE-MOBILE.3a52388a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blog/BLOG-TITLE-MOBILE.png
// module id = 497
// module chunks = 212839066777427